
<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()" (action)="handleHeaderAction($event)">
  <div ngProjectAs="filters">
    @switch (mapLayer().uiHandle) {
      @case ('serviceTerritories') {
        <tgrid-single-select-filter placeholder="Type"  (filterChange)="updateCqlFilter('SELECT', 'type', $event)"></tgrid-single-select-filter>
        <tgrid-text-filter (filterChange)="updateCqlFilter('TEXT_SEARCH', 'holding_co', $event)"></tgrid-text-filter>
      }
      @case ('eiaAdvancedMeter') {
        <tgrid-single-select-filter placeholder="Service Region Type" (filterChange)="updateCqlFilter('SELECT', 'type', $event)"></tgrid-single-select-filter>
      }
      @case ('eiaDistributionSystems') {
        <tgrid-single-select-filter placeholder="Service Region Type" (filterChange)="updateCqlFilter('SELECT', 'type', $event)"></tgrid-single-select-filter>
      }
      @case ('eiaReliability') {
        <tgrid-single-select-filter placeholder="Service Region Type" (filterChange)="updateCqlFilter('SELECT', 'type', $event)"></tgrid-single-select-filter>
      }
      @case ('eiaReliabilityFrequency') {
        <tgrid-single-select-filter placeholder="Service Region Type" (filterChange)="updateCqlFilter('SELECT', 'type', $event)"></tgrid-single-select-filter>
      }
    }

    @if (selectOptions().length !== 0) {
      <mat-form-field appearance="outline">
        <mat-label>Attribute</mat-label>
        <mat-select placeholder="Attribute" [formControl]="attributeControl">
          @for (row of selectOptions(); track row) {
            <mat-option [value]="row">{{ row.displayName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  @if (checked && mapLayer().legend.imageUrl()) {
    <img [src]="mapLayer().legend.imageUrl()" alt="">
  }
</tgrid-layer-header>
